
import { WarningLightComponent } from './views/warning-light/warning-light.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalModule } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import * as fromEnums from '../../../../projects/Autofacets-Core/src/app/utils/enums'

import { ServiceAdvisorComponent } from './components/service-advisor/service-advisor.component';
import { EditBrandGuard } from './guards/edit-brand-guard/edit-brand-guard.service';
import { EditDealerGuard } from './guards/edit-dealer-guard/edit-delaer-guard.service';
import { EditDealerHolidayGuard } from './guards/edit-dealer-holiday-guard/edit-dealer-holiday-guard.service';
import { EditKeydropLocationGuard } from './guards/edit-dealer-keydrop-location/edit-dealer-keydrop-location.service';
import { EditDealerPartsServiceGuard } from './guards/edit-dealer-parts-guard/edit-dealer-parts-guard.service';
import { EditDealerServiceGuard } from './guards/edit-dealer-service-guard/edit-dealer-service-guard.service';
import { EditDiagnoseTemplateGuard } from './guards/edit-diagnose-template-guard/edit-diagnose-template-guard.service';
import { EditMechanicServiceGuard } from './guards/edit-mechanic-guard/edit-mechanic-guard.service';
import { EditMechanicTimeCodeGuard } from './guards/edit-mechanic-timecode-guard/edit-mechanic-timecode-guard.service';
import { EditPackageGuard } from './guards/edit-package-guard/edit-package-guard.service';
import { EditPartsServiceGuard } from './guards/edit-parts-guard/edit-parts-guard.service';
import { EditReceptionGuard } from './guards/edit-reception-guard/edit-reception-guard.service';
import { EditRentalCarGuard } from './guards/edit-rental-car-guard/edit-rental-car-guard.service';
import { EditRoleRightsGuard } from './guards/edit-role-rights/edit-role-rights-guard.service';
import { EditServiceCategoryGuard } from './guards/edit-service-category-guard/edit-service-category-guard.service';
import { EditServiceGuard } from './guards/edit-service-guard/edit-service-guard.service';
import { EdiSpecialToolGuard } from './guards/edit-special-tool-guard/edit-special-tool-guard.service';
import { EditTechnicalManualGuard } from './guards/edit-technical-manual-guard/edit-technical-manual-guard.service';
import { EditTemplateGuard } from './guards/edit-template-guard/edit-template-guard.service';
import { VehicleGuard } from './guards/edit-vehicle-guard/edit-vehicle-guard.service';
import { RoleAccessGuard } from './guards/role-access/role-access-guard.service';
import { UserStampGuard } from './guards/user-stamp-guard/user-stamp-guard.service';
import { ViewAutoKeyGuard } from './guards/view-autokey-guard/view-autokey-guard.service';
import { ViewCustomerGuard } from './guards/view-customer-details-guard/view-customer-details-guard';
import { ViewAccountDetailsGuard } from './guards/view-account-details-guard/view-account-details-guard'
import { AfxSyncfailedlogComponent } from './views/afx-syncfailedlog/afx-syncfailedlog.component';
import { ApplicationVersionComponent } from './views/application-version/application-version.component';
import { AppointmentComponent } from './views/appointment/appointment.component';
import { AddAutoKeyComponent } from './views/auto-key/auto-key/add-auto-key/add-auto-key/add-auto-key.component';
import { AutoKeyComponent } from './views/auto-key/auto-key/auto-key.component';
import { ViewAutoKeyComponent } from './views/auto-key/auto-key/view-auto-key/view-auto-key/view-auto-key.component';
import { AddBrandComponent } from './views/brand/add-brand/add-brand/add-brand.component';
import { BrandComponent } from './views/brand/brand/brand.component';
import { EditBrandComponent } from './views/brand/edit-brand/edit-brand/edit-brand.component';
import { CampaignComponent } from './views/campaign-management/campaign/campaign.component';
import { CampaignTemplateComponent } from './views/campaign-management/campaign-template/campaign-template.component';
import { TargetedGroupComponent } from './views/campaign-management/targeted-group/targeted-group.component';
import { AddCheckListItemsComponent } from './views/check-list-management/add-check-list-items/add-check-list-items.component';
import { AddCheckListComponent } from './views/check-list-management/add-check-list/add-check-list.component';
import { CheckListManagementComponent } from './views/check-list-management/check-list-management.component';
import { AddCompetenceComponent } from './views/competence/add-competence/add-competence.component';
import { CompetenceComponent } from './views/competence/competence/competence.component';
import { EditCompetenceComponent } from './views/competence/edit-competence/edit-competence.component';
import { CustomerComponent } from './views/customer/customer.component';
import { CustomerDetailsComponent } from './views/customer/view-customer/customer-details/customer-details.component';
import { VehicleListComponent } from './views/customer/view-customer/vehicle-list/vehicle-list.component';
import { VehiclesComponent } from './views/customer/view-customer/vehicles/vehicles.component';
import { ViewCustomerComponent } from './views/customer/view-customer/view-customer.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { AddDealerHolidayComponent } from './views/dealer-holiday/add-dealer-holiday/add-dealer-holiday.component';
import { DealerHolidayComponent } from './views/dealer-holiday/dealer-holiday.component';
import { EditDealerHolidayComponent } from './views/dealer-holiday/edit-dealer-holiday/edit-dealer-holiday.component';
import { AddDealerKeydropLocationComponent } from './views/dealer-keydrop-location/add-dealer-keydrop-location/add-dealer-keydrop-location.component';
import { DealerKeydropLocationComponent } from './views/dealer-keydrop-location/dealer-keydrop-location.component';
import { EditDealerKeydropLocationComponent } from './views/dealer-keydrop-location/edit-dealer-keydrop-location/edit-dealer-keydrop-location.component';
import { DealerParkingComponent } from './views/dealer-parking/dealer-parking/dealer-parking.component';
import { AddDealerPartsComponent } from './views/dealer-parts/add-dealer-parts/add-dealer-parts.component';
import { DealerPartsComponent } from './views/dealer-parts/dealer-parts.component';
import { EditDealerPartsComponent } from './views/dealer-parts/edit-dealer-parts/edit-dealer-parts.component';
import { AddDealerServiceComponent } from './views/dealer-service/add-dealer-service/add-dealer-service.component';
import { DealerServiceComponent } from './views/dealer-service/dealer-service.component';
import { EditDealerServiceComponent } from './views/dealer-service/edit-dealer-service/edit-dealer-service.component';
import { AddDealerSpecialToolComponent } from './views/dealer-special-tool/dealer-special-tool/add-dealer-special-too/add-dealer-special-tool/add-dealer-special-tool.component';
import { DealerSpecialToolComponent } from './views/dealer-special-tool/dealer-special-tool/dealer-special-tool.component';
import { EditDealerSpecialToolComponent } from './views/dealer-special-tool/dealer-special-tool/edit-dealer-special-tool/edit-dealer-special-tool/edit-dealer-special-tool.component';
import { AddDealerComponent } from './views/dealer/add-dealer/add-dealer.component';
import { GetDmsDealerComponent } from './views/dealer/get-dms-dealer/get-dms-dealer.component';
import { DealerComponent } from './views/dealer/dealer.component';
import { EditDealerComponent } from './views/dealer/edit-dealer/edit-dealer.component';
import { AddDiagnoseCheckListItemsComponent } from './views/diagnose-check-list/diagnose-check-list/add-diagnose-check-list-items/add-diagnose-check-list-items.component';
import { AddDiagnoseCheckListComponent } from './views/diagnose-check-list/diagnose-check-list/add-diagnose-check-list/add-diagnose-check-list/add-diagnose-check-list.component';
import { DiagnoseCheckListComponent } from './views/diagnose-check-list/diagnose-check-list/diagnose-check-list.component';
import { AddDiagnoseTemplateComponent } from './views/diagnose-template/diagnose-template/add-diagnose-template/add-diagnose-template/add-diagnose-template.component';
import { DiagnoseTemplateComponent } from './views/diagnose-template/diagnose-template/diagnose-template.component';
import { EditDiagnoseTemplateComponent } from './views/diagnose-template/diagnose-template/edit-diagnose-template/edit-diagnose-template/edit-diagnose-template.component';
import { DmsValuesComponent } from './views/dms-defaultvalues/dms-values/dms-values.component';
import { DmsSyncfailedlogComponent } from './views/dms-syncfailedlog/dms-syncfailedlog.component';
import { FeatureComponent } from './views/feature/feature.component';
import { LogofSmsEmailSentComponent } from './views/logof-sms-email-sent/logof-sms-email-sent.component';
import { MapAppointmentStatusComponent } from './views/map-appointment-status/map-appointment-status.component';
import { AddMechanicTimeCodeComponent } from './views/mechanic-time-code/mechanic-time-code/add-mechanic-time-code/add-mechanic-time-code/add-mechanic-time-code.component';
import { EditMechanicTimeCodeComponent } from './views/mechanic-time-code/mechanic-time-code/edit-mechanic-time-code/edit-mechanic-time-code/edit-mechanic-time-code.component';
import { MechanicTimeCodeComponent } from './views/mechanic-time-code/mechanic-time-code/mechanic-time-code.component';
import { AddMechanicComponent } from './views/mechanic/add-mechanic/add-mechanic.component';
import { EditBasicDetailsMechanicComponent } from './views/mechanic/edit-basic-details-mechanic/edit-basic-details-mechanic.component';
import { EditCompetenceMechanicComponent } from './views/mechanic/edit-competence-mechanic/edit-competence-mechanic.component';
import { EditHoursMechanicComponent } from './views/mechanic/edit-hours-mechanic/edit-hours-mechanic.component';
import { EditCustomerWaitingHoursMechanicComponent } from './views/mechanic/edit-customer-waiting-hours-mechanic/edit-customer-waiting-hours-mechanic.component';
import { EditLeavesMechanicComponent } from './views/mechanic/mechanic-leave/edit-leaves-mechanic/edit-leaves-mechanic.component';
import { EditMechanicComponent } from './views/mechanic/edit-mechanic/edit-mechanic.component';
import { MechanicRecipientListComponent } from './views/mechanic/mechanic-recipient-list/mechanic-recipient-list.component';
import { MechanicComponent } from './views/mechanic/mechanic.component';
import { AddPackageComponent } from './views/package/add-package/add-package.component';
import { PackageComponent } from './views/package/package.component';
import { AddPartsComponent } from './views/parts/add-parts/add-parts.component';
import { EditPartsComponent } from './views/parts/edit-parts/edit-parts.component';
import { PartsComponent } from './views/parts/parts/parts.component';
import { PlanningComponent } from './views/planning/planning.component';
import { AddReceptionComponent } from './views/reception/add-reception/add-reception.component';
import { EditReceptionComponent } from './views/reception/edit-reception/edit-reception.component';
import { ReceptionComponent } from './views/reception/reception.component';
import { AddRentalCarComponent } from './views/Rental-Car/add-rental-car/add-rental-car.component';
import { EditRentalCarComponent } from './views/Rental-Car/edit-rental-car/edit-rental-car.component';
import { RentalCarComponent } from './views/Rental-Car/rental-car.component';
import { CustomerDropComponent } from './views/report/customer-drop/customer-drop.component';
import { CustomerWaitingComponent } from './views/report/customer-waiting/customer-waiting.component';
import { MechanicClockingTimeComponent } from './views/report/mechanic-clocking-time/mechanic-clocking-time.component';
import { PickupDropoffComponent } from './views/report/pickup-dropoff/pickup-dropoff.component';
import { EditRolesRightsComponent } from './views/roles-rights/edit-roles-rights/edit-roles-rights.component';
import { RolesRightsComponent } from './views/roles-rights/roles-rights.component';
import { AddServiceCategoryComponent } from './views/service-category/add-service-category/add-service-category/add-service-category.component';
import { EditServiceCategoryComponent } from './views/service-category/edit-service-category/edit-service-category/edit-service-category.component';
import { ServiceCategoryComponent } from './views/service-category/service-category.component';
import { AddServiceComponent } from './views/services/add-service/add-service.component';
import { EditServiceComponent } from './views/services/edit-service/edit-service.component';
import { ServicesComponent } from './views/services/services.component';
import { AddSpecialToolComponent } from './views/special-tool/add-special-tool/add-special-tool/add-special-tool.component';
import { EditSpecialToolComponent } from './views/special-tool/edit-special-tool/edit-special-tool/edit-special-tool.component';
import { SpecialToolComponent } from './views/special-tool/special-tool/special-tool.component';
import { StatusConfigurationComponent } from './views/status-configuration/status-configuration.component';
import { SyncJobsComponent } from './views/sync-jobs/sync-jobs.component';
import { AddTechnicalManualComponent } from './views/technical-manual/technical-manual/add-technical-manual/add-technical-manual/add-technical-manual.component';
import { TechnicalManualComponent } from './views/technical-manual/technical-manual/technical-manual.component';
import { ViewTechnicalManualComponent } from './views/technical-manual/technical-manual/view-technical-manual/view-technical-manual/view-technical-manual.component';
import { AddTemplateComponent } from './views/template/add-template/add-template.component';
import { EditTemplateComponent } from './views/template/edit-template/edit-template.component';
import { TemplateComponent } from './views/template/template.component';
import { TimeStampComponent } from './views/time-stamp/time-stamp.component';
import { EditVehicleComponent } from './views/vehicle/edit-vehicle/edit-vehicle.component';
import { VehicleManagementComponent } from './views/vehicle/vehicle-management.component';
import { WidgetAppointmentRequestComponent } from './views/widget-appointment-request/widget-appointment-request.component';
import { AccountsComponent } from './views/accounts/accounts.component';
import { ViewAccountComponent } from './views/accounts/view-account/view-account.component';
import { ContactDetailsComponent } from './views/accounts/view-account/contact-details/contact-details.component';
import { AccountDetailsComponent } from './views/accounts/view-account/account-details/account-details.component';
import { AddAccountComponent } from './views/accounts/add-account/add-account.component';
import { AddAccountDetailsGuard } from './guards/add-account-guard/add-account-guard';
import { LaborComponent } from './views/labor/labor.component';
import { ViewAllNotificationsComponent } from './views/notification-details/view-all-notifications/view-all-notifications.component';
import { ContactUserComponent } from './views/report/contact-user/contact-user.component';
import { AppointmentLockingComponent } from './views/appointment-locking/appointment-locking.component';
import { AddMulticplourChecklistItemComponent } from './views/check-list-management/add-multicplour-checklist-item/add-multicplour-checklist-item.component';
import { DmsSyncschedulerlogComponent } from './views/dms-syncschedulerlog/dms-syncschedulerlog.component';
import { ActionTypeComponent } from './views/action-type/action-type.component';
import { MechanicEfficiencyReportComponent } from './views/report/mechanic-efficiency-report/mechanic-efficiency-report.component';
import { MechanicReportComponent } from './views/report/mechanic-report/mechanic-report.component';
import {ServiceMechanicWiseReportComponent} from './views/report/service-mechanic-wise-report/service-mechanic-wise-report.component';
import { ArchivedAppointmentComponent } from './views/archived-appointment/archived-appointment.component';
import { DeletedVehiclesComponent } from './views/deleted-vehicles/deleted-vehicles.component';
import { DeletedCustomerComponent } from './views/deleted-customer/deleted-customer.component';
import { PreferencesComponent } from './views/preferences/preferences.component';
import { PromotionsComponent } from './views/promotions/promotions.component';
import { CategoryComponent } from './views/category/category.component';
import { AutomaticUpdatesComponent } from './views/automatic-updates/automatic-updates.component';
import { DealerWiseAgentListComponent } from './views/report/agent-efficiency/dealer-wise-agent-list/dealer-wise-agent-list.component';
import { CheckinUserComponent } from './views/report/checkin-user/checkin-user.component';
import { DeletedPlanningComponent } from './views/report/deleted-planning/deleted-planning.component';
import { DealerWiseCallHistoryComponent } from './views/report/call-dealer-logs/dealer-wise-call-history/dealer-wise-call-history.component';
import { UserViseAppointmentComponent } from './views/report/user-vise-appointment/user-vise-appointment.component';
import { CdssAppointmentComponent } from './views/report/cdss-appointment/cdss-appointment.component';
import { TimeStampReportComponent } from './views/report/time-stamp-report/time-stamp-report.component';
import { PartSalesPriceCalculationComponent } from './views/part-calculation/part-sales-price-calculation/part-sales-price-calculation.component';
import { LaborChargingGroupPriceComponent } from './views/labor/labor-charging-group/labor-charging-group-price/labor-charging-group-price.component';
import { TotalSoldHoursReportComponent } from './views/report/total-sold-hours-report/total-sold-hours-report.component';
import { ExceptionLogListComponent } from './views/exception-log-list/exception-log-list.component';
import { UserClockInOutComponent } from './views/user-clock-in-out/user-clock-in-out.component';
import { UserStampReportComponent } from './views/user-stamp-report/user-stamp-report.component';
import { WorkOrderStatusComponent } from './views/report/work-order-status/work-order-status.component';
import { TowedInReportComponent } from './views/report/towed-in-report/towed-in-report.component';
import { AdditionalWorkReportComponent } from './views/report/additional-work-report/additional-work-report.component';
import { WorkorderTimeStampReportComponent } from './views/report/workorder-time-stamp-report/workorder-time-stamp-report.component';
import { SyncFailAppointmentComponent } from './views/appointment/sync-fail-appointment/sync-fail-appointment.component';
import { WidgetAppointmentReportComponent } from './views/report/widget-appointment-report/widget-appointment-report.component';
import { ErrorLogAnalysisReportComponent } from './views/report/error-log-analysis-report/error-log-analysis-report.component';

const routes: Routes = [

  {
    path: 'dashboard',
    data: { title: 'lblDashboard', id: fromEnums.ModuleNames.Dashboard, isMain: true, breadcrumb: 'lblDashboard' },
    canActivate: [MsalGuard, RoleAccessGuard],
    component: DashboardComponent
  },
  {
    path: 'incoming-call',
    data: { title: 'lblDashboard', id: fromEnums.ModuleNames.Dashboard, isMain: true, breadcrumb: 'lblDashboard' },
    canActivate: [MsalGuard],
    component: DashboardComponent
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    data: { title: 'lblDashboard', breadcrumb: 'lblDashboard' },
  },
  {
    path: 'view-all-notifications',
    data: { title: 'lblAllNotifications',id: fromEnums.ModuleNames.HeaderNotification, breadcrumb: 'lblAllNotifications'},
    component: ViewAllNotificationsComponent
  },
  {
    path: '',
    data: { breadcrumb: 'lblDealerSetup' },
    children: [
      {
        path: 'dealer',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblDealers', id: fromEnums.ModuleNames.DealerDetails, breadcrumb: 'lblDealers' },
        children: [
          {
            path: '',
            data: { title: 'lblDealers', isMain: true, breadcrumb: '' },
            component: DealerComponent
          },
          {
            path: 'add-dealer',
            component: AddDealerComponent,
            data: { title: 'lblDealers', isAdd: true, breadcrumb: 'lblAddDealer' }
          },
          {
            path: 'dms-dealer',
            component: GetDmsDealerComponent,
            data: { title: 'lblDealers', isAdd: true, breadcrumb: 'lblAddDealer' }
          },
          {
            path: 'edit-dealer',
            canActivate: [EditDealerGuard],
            component: EditDealerComponent,
            data: { title: 'lblDealers', isEdit: true, breadcrumb: 'lblEditDealer' }
          }
        ]
      },
      {
        path: 'user',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblUsers', id: fromEnums.ModuleNames.Reception, breadcrumb: 'lblUsers' },
        children: [
          {
            path: '',
            data: { title: 'lblUsers',isMain: true, breadcrumb: '' },
            component: ReceptionComponent
          },
          {
            path: 'add-user',
            component: AddReceptionComponent,
            data: { title: 'lblUsers', isAdd: true, breadcrumb: 'lblAdduser' }
          },
          {
            path: 'edit-user',
            component: EditReceptionComponent,
            canActivate: [EditReceptionGuard],
            data: { title: 'lblUsers', isEdit: true, breadcrumb: 'lblEditUser' }
          }
        ]
      },
      {
        path: 'dealer-holiday',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblNationalHolidays', id: fromEnums.ModuleNames.DealerHoliday, breadcrumb: 'lblNationalHolidays' },
        children: [
          {
            path: '',
            data: { title: 'lblNationalHolidays', isMain: true, breadcrumb: '' },
            component: DealerHolidayComponent
          },
          {
            path: 'add-dealer-holiday',
            component: AddDealerHolidayComponent,
            data: { title: 'lblNationalHolidays', isAdd: true, breadcrumb: 'lblAddDealerHoliday' }
          },
          {
            path: 'edit-dealer-holiday',
            component: EditDealerHolidayComponent,
            canActivate: [EditDealerHolidayGuard],
            data: { title: 'lblNationalHolidays', isEdit: true, breadcrumb: 'lblEditDealerHoliday' }
          }
        ]
      },
      {
        path: 'dealer-service',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblDealerService', id: fromEnums.ModuleNames.DealerService, breadcrumb: 'lblDealerService' },
        children: [
          {
            path: '',
            data: { title: 'lblDealerService', isMain: true, breadcrumb: '' },
            component: DealerServiceComponent
          },
          {
            path: 'add-dealer-service',
            component: AddDealerServiceComponent,
            data: { title: 'lblDealerService', isAdd: true, breadcrumb: 'lblAddDealerService' }
          },
          {
            path: 'edit-dealer-service',
            component: EditDealerServiceComponent,
            canActivate: [EditDealerServiceGuard],
            data: { title: 'lblDealerService', isEdit: true, breadcrumb: 'lblEditDealerService' }
          }
        ]
      },
      {
        path: 'rentalvehicle',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblRentalCars', id: fromEnums.ModuleNames.RentalVehicle, breadcrumb: 'lblRentalCars' },
        children: [
          {
            path: '',
            data: { title: 'lblRentalCars', isMain: true, breadcrumb: '' },
            component: RentalCarComponent
          },
          {
            path: 'add-rentalvehicle',
            data: { title: 'lblRentalCars', isAdd: true, breadcrumb: 'lblAddRentalCar' },
            component: AddRentalCarComponent
          },
          {
            path: 'edit-rentalvehicle',
            canActivate: [EditRentalCarGuard],
            data: { title: 'lblRentalCars', isEdit: true, breadcrumb: 'lblEditRentalCar' },
            component: EditRentalCarComponent
          }
        ]
      },
      {
        path: 'dealerparts',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblDealerParts', id: fromEnums.ModuleNames.DealerParts, breadcrumb: 'lblDealerParts' },
        children: [
          {
            path: '',
            data: { title: 'lblDealerParts', isMain: true, breadcrumb: '' },
            component: DealerPartsComponent
          },
          {
            path: 'add-dealer-parts',
            data: { title: 'lblDealerParts', isAdd: true, breadcrumb: 'lblAddDealerParts' },
            component: AddDealerPartsComponent
          },
          {
            path: 'edit-dealer-parts/:id',
            data: { title: 'lblDealerParts', isEdit: true, breadcrumb: 'lblEditDealerParts' },
            component: EditDealerPartsComponent,
            canActivate: [EditDealerPartsServiceGuard]
          }
        ]
      },
      {
        path: 'dealerSpecialTool',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblBrandTools',
          id: fromEnums.ModuleNames.DealerSpecialTools,
          breadcrumb: 'lblBrandTools'
        },
        children: [
          {
            path: '',
            data: { title: 'lblBrandTools', isMain: true, breadcrumb: '' },
            component: DealerSpecialToolComponent
          },
          {
            path: 'edit-dealerSpecialTool/:id',
            data: { title: 'lblBrandTools', isEdit: true, breadcrumb: 'lblEditDealerSpecialTool' },
            component: EditDealerSpecialToolComponent
          },
          {
            path: 'add-dealerSpecialTool',
            data: { title: 'lblBrandTools', isAdd: true, breadcrumb: 'lblAssignTool' },
            component: AddDealerSpecialToolComponent
          }
        ]
      },
      {
        path: 'mechanic',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblMechanics', id: fromEnums.ModuleNames.Mechanic, breadcrumb: 'lblMechanics' },
        children: [
          {
            path: '',
            data: { title: 'lblMechanics', isMain: true, breadcrumb: '' },
            component: MechanicComponent
          },
          {
            path: 'add',
            component: AddMechanicComponent,
            data: { title: 'lblMechanics', isAdd: true, breadcrumb: 'lblAddMechanic' }
          },
          {
            path: 'edit',
            component: EditMechanicComponent,
            canActivate: [EditMechanicServiceGuard],
            data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblEditMechanic' },
            children: [
              {
                path: 'leaves',
                data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblLeaves' },
                component: EditLeavesMechanicComponent
              },
              {
                path: 'basic',
                data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblDetails' },
                component: EditBasicDetailsMechanicComponent
              },
              {
                path: 'hours',
                data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblShiftTimings' },
                component: EditHoursMechanicComponent
              },
              {
                path: 'customer-waiting-hours',
                data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblCustomerWaiting' },
                component: EditCustomerWaitingHoursMechanicComponent
              },
              {
                path: 'recipent-list',
                data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblMechanicReceipentList' },
                component: MechanicRecipientListComponent
              },
              {
                path: 'competence',
                data: { title: 'lblMechanics', isEdit: true, breadcrumb: 'lblCompetence/Skills' },
                component: EditCompetenceMechanicComponent
              }
            ]
          }
        ]
      },
    ]
  },
  {
    path: '',
    data: { breadcrumb: 'lblPlanner' },
    children: [
      {
        path: 'appointment',
        // component: AppointmentComponent,
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblAppointment', id: fromEnums.ModuleNames.Appointment, breadcrumb: 'lblAppointment'},
        children:[{
          path:'',
          data: { title: 'lblAppointment',  breadcrumb: '',isMain:true },
          component: AppointmentComponent,
        }
        ]
      },
      {
        path: 'archived-appointment',
        // component: ArchivedAppointmentComponent,
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblArchivedAppointment', id: fromEnums.ModuleNames.Appointment, breadcrumb: 'lblArchivedAppointment'},
        children:[{
          path:'',
          data: { title: 'lblArchivedAppointment',  breadcrumb: '',isMain:true },
          component: ArchivedAppointmentComponent,
        }
        ]
      },
      {
        path: 'customer',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblCustomers', id: fromEnums.ModuleNames.Customer, breadcrumb: 'lblCustomers' },
        children: [
          {
            path: '',
            data: { title: 'lblCustomers',isMain: true, breadcrumb: '' },
            component: CustomerComponent
          },
          {
            path: 'view-customer',
            component: ViewCustomerComponent,
            data: { title: 'lblCustomers',isMain: true, breadcrumb: 'lblViewCustomer' },
            canActivateChild: [ViewCustomerGuard],
            children: [
              {
                path: '',
                redirectTo: 'details',
                pathMatch: 'full',
                data: { title: 'lblCustomers',breadcrumb: 'lblViewCustomer' },
              },
              {
                path: 'details',
                data: { title: 'lblCustomers',isMain: true, breadcrumb: 'lblCustomerDetails' },
                component: CustomerDetailsComponent,
              },
              {
                path: 'vehicles',
                data: { title: 'lblCustomers',isMain: true, breadcrumb: 'lblVehicleDetails' },
                component: VehiclesComponent,
                children: [
                  {
                    path: '',
                    redirectTo: 'list',
                    pathMatch: 'full',
                    data: { title: 'lblCustomers',breadcrumb: 'lblVehicleDetails' },
                  },
                  {
                    path: 'list',
                    data: { isMain: true },
                    component: VehicleListComponent
                  }

                ]
              },
              {
                path: 'communication',
                data: { title: 'lblCommunication',isMain: true, breadcrumb: 'lblCommunication' },
                component: CustomerDetailsComponent,
              },
            ]
          }
        ]
      },
      {
        path: 'account',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblAccounts', id: fromEnums.ModuleNames.Accounts, breadcrumb: 'lblAccounts' },
        children: [
          {
            path: '',
            data: { title: 'lblAccounts',isMain: true, breadcrumb: '' },
            component: AccountsComponent
          },
          {
            path: 'view-account',
            component: ViewAccountComponent,
            data: { title: 'lblViewAccount',isMain: true, breadcrumb: 'lblViewAccount' },
            canActivateChild: [ViewAccountDetailsGuard],
            children: [
              {
                path: '',
                redirectTo: 'view-account',
                pathMatch: 'full',
                data: { title: 'lblViewAccount',breadcrumb: 'lblViewAccount' },
              },
              {
                path: 'account-details',
                data: { title: 'lblAccounts',isMain: true, breadcrumb: 'lblAccountDetails' },
                component: AccountDetailsComponent,
              },
              {
                path: 'contact-details',
                data: { title: 'lblaccounts',isMain: true, breadcrumb: 'lblContactDetails' },
                component: ContactDetailsComponent,
              }
            ]
          },
          {
            path: 'add-account',
            component: AddAccountComponent,
            data: { title: 'lblAddAccount', isMain: true, breadcrumb: 'lblAddAccount'},
            canActivateChild: [AddAccountDetailsGuard],
            children: [
              {
                path: '',
                redirectTo: 'add-account',
                pathMatch: 'full',
                data: { title: 'lblAddAccount', isMain: true, breadcrumb: 'lblAddAccount'}
              }
            ]
          }
        ]
      },
      {
        path: 'planning',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblPlanning', id: fromEnums.ModuleNames.Planning, breadcrumb: 'lblPlanning' },
        children: [
          {
            path: '',
            data: { title: 'lblPlanning',isMain: true, breadcrumb: '' },
            component: PlanningComponent
          }
        ]
      },
      {
        path: 'widget-appointment',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblWidgetAppointmentRequests', id: fromEnums.ModuleNames.WidgetAppointment, breadcrumb: 'lblWidgetAppointmentRequests' },
        children: [
          {
            path: '',
            data: { title: 'lblWidgetAppointmentRequests',isMain: true, breadcrumb: '' },
            component: WidgetAppointmentRequestComponent
          }
        ]
      },
      {
        path: 'appointment-locking',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblAppointmentLock', id: fromEnums.ModuleNames.AppointmentLock, breadcrumb: 'lblAppointmentLock' },
        children: [
          {
            path: '',
            data: { title: 'lblAppointmentLock',isMain: true, breadcrumb: '' },
            component: AppointmentLockingComponent
          }
        ]
      },
      {
        path: 'service-advisor',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblServiceAdvisor', id: fromEnums.ModuleNames.ServiceAdvisor, breadcrumb: 'lblServiceAdvisor' },
        children: [
          {
            path: '',
            data: { title: 'lblServiceAdvisor',isMain: true, breadcrumb: '' },
            component: ServiceAdvisorComponent
          }
        ]
      },
      {
        path: 'vehicle',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblVehicle', id: fromEnums.ModuleNames.Vehicle, breadcrumb: 'lblVehicle' },
        children: [
          {
            path: '',
            data: { title: 'lblVehicle',isMain: true, breadcrumb: '' },
            component: VehicleManagementComponent
          },
          {
            path: 'edit-vehicle',
            component: EditVehicleComponent,
            canActivate: [VehicleGuard],
            data: { title: 'lblVehicle', isEdit: true, breadcrumb: 'lblEditVehicleDetails' }
          }
        ]
      },
      {
        path: 'status-configuration',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblAppointmentStatus',
          id: fromEnums.ModuleNames.StatusConfiguration,
          breadcrumb: 'lblAppointmentStatus'
        },
        children: [
          {
            path: '',
            data: { title: 'lblAppointmentStatus', isMain: true, breadcrumb: '' },
            component: StatusConfigurationComponent
          }
        ]
      },
      {
        path: 'map-appointment-status',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblMapNextAvailableStatus',
          id: fromEnums.ModuleNames.AppointmentStatusConfig,
          breadcrumb: 'lblMapNextAvailableStatus'
        },
        children: [
          {
            path: '',
            data: { title: 'lblMapNextAvailableStatus', isMain: true, breadcrumb: '' },
            component: MapAppointmentStatusComponent
          }
        ]
      },
      {
        path: 'template',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblMessageTemplates', id: fromEnums.ModuleNames.Template, breadcrumb: 'lblMessageTemplates' },
        children: [
          {
            path: '',
            data: { title: 'lblMessageTemplates', isMain: true, breadcrumb: '' },
            component: TemplateComponent
          },
          {
            path: 'add-template',
            data: { title: 'lblMessageTemplates', isAdd: true, breadcrumb: 'lblAddTemplate' },
            component: AddTemplateComponent
          },
          {
            path: 'edit-template',
            data: { title: 'lblMessageTemplates', isEdit: true, breadcrumb: 'lblEditTemplate' },
            component: EditTemplateComponent,
            canActivate: [EditTemplateGuard]
          }
        ]
      },
      {
        path: 'logof-sms-sent',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblSMSLogScreen', id: fromEnums.ModuleNames.LogofSmsEmailSent, breadcrumb: 'lblSMSLogScreen' },
        children: [
          {
            path: '',
            data: { title: 'lblSMSLogScreen', isMain: true, breadcrumb: '' },
            component: LogofSmsEmailSentComponent
          }
        ]
      },
      {
        path: 'automatic-updates',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblAutomaticUpdates', id: fromEnums.ModuleNames.AutomaticUpdates, breadcrumb: 'lblAutomaticUpdates' },
        children: [
          {
            path: '',
            data: { title: 'lblAutomaticUpdates', isMain: true, breadcrumb: '' },
            component: AutomaticUpdatesComponent
          }
        ]
      },
      {
        path: 'dms-syncfailedlog',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblDMSSyncFailedlog', id: fromEnums.ModuleNames.DMSSyncFailedlog, breadcrumb: 'lblDMSSyncFailedlog' },
        children: [
          {
            path: '',
            data: { title: 'lblDMSSyncFailedlog', isMain: true, breadcrumb: '' },
            component: DmsSyncfailedlogComponent
          }
        ]
      },
      {
        path: 'afx-syncfailedlog',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblAFXSyncFailedlog', id: fromEnums.ModuleNames.DMSSyncFailedlog, breadcrumb: 'lblAFXSyncFailedlog' },
        children: [
          {
            path: '',
            data: { title: 'lblAFXSyncFailedlog', isMain: true, breadcrumb: '' },
            component: AfxSyncfailedlogComponent
          }
        ]
      },
      {
        path: 'dms-syncschedulerlog',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblDmsSyncSchedulerLog', id: fromEnums.ModuleNames.DMSSyncFailedlog, breadcrumb: 'lblDmsSyncSchedulerLog' },
        children: [
          {
            path: '',
            data: { title: 'lblDmsSyncSchedulerLog', isMain: true, breadcrumb: '' },
            component: DmsSyncschedulerlogComponent
          }
        ]
      },
      {
        path: 'exception-log',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblExceptionLog', id: fromEnums.ModuleNames.SmartPlannerExceptionLog, breadcrumb: 'lblExceptionLog' },
        children: [
          {
            path: '',
            data: { title: 'lblExceptionLog', isMain: true, breadcrumb: '' },
            component: ExceptionLogListComponent
          }
        ]
      },   
      {
        path: 'autoKey',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblAutokey', id: fromEnums.ModuleNames.AutoKey, breadcrumb: 'lblAutokey' },
        children: [
          {
            path: '',
            data: { title: 'lblAutokey', isMain: true, breadcrumb: '' },
            component: AutoKeyComponent
          },
          {
            path: 'view-autoKey',
            canActivate: [ViewAutoKeyGuard],
            component: ViewAutoKeyComponent,
            data: { title: 'lblAutokey', isMain: true, breadcrumb: 'lblAppointmentAutoKeyDetails' }
          },
          {
            path: 'add-autoKey',
            component: AddAutoKeyComponent,
            data: { title: 'lblAutokey', isAdd: true, breadcrumb: 'lblEditAutoKeyDetails' }
          }
        ]
      },   
    ]
  },
  {
    path: '',
    data: { breadcrumb: 'lblConfigurations' },
    children: [
      {
        path: '',
        data: { breadcrumb: 'lblWorkshop' },
        children: [
          {
            path: 'brand',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblBrands',
              id: fromEnums.ModuleNames.Brand,
              breadcrumb: 'lblBrands'
            },
            children: [
              {
                path: '',
                data: { title: 'lblBrands', isMain: true, breadcrumb: '' },
                component: BrandComponent
              },
              {
                path: 'add-brand',
                component: AddBrandComponent,
                data: { title: 'lblBrands', isAdd: true, breadcrumb: 'lblAddBrand' }
              },
              {
                path: 'edit-brand',
                component: EditBrandComponent,
                canActivate: [EditBrandGuard],
                data: { title: 'lblBrands', isEdit: true, breadcrumb: 'lblEditBrand' }
              }
            ]
          },
          {
            path: 'competence',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblCompetencies',
              id: fromEnums.ModuleNames.competence,
              breadcrumb: 'lblCompetencies'
            },
            children: [
              {
                path: '',
                data: { title: 'lblCompetencies', isMain: true, breadcrumb: '' },
                component: CompetenceComponent
              },
              {
                path: 'add-competence',
                component: AddCompetenceComponent,
                data: { title: 'lblCompetencies', isAdd: true, breadcrumb: 'lblAddCompetence' }
              },
              {
                path: 'edit-competence',
                component: EditCompetenceComponent,
                data: { title: 'lblCompetencies', isEdit: true, breadcrumb: 'lblEditCompetence' }
              }
            ]
          },
          {
            path: 'service-categories',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblServiceCategories',
              id: fromEnums.ModuleNames.ServiceCategory,
              breadcrumb: 'lblServiceCategories'
            },
            children: [
              {
                path: '',
                data: { title: 'lblServiceCategories', isMain: true, breadcrumb: '' },
                component: ServiceCategoryComponent
              },
              {
                path: 'add-categories',
                component: AddServiceCategoryComponent,
                data: { title: 'lblServiceCategories', isAdd: true, breadcrumb: 'lblAddServiceCategory' }
              },
              {
                path: 'edit-categories',
                component: EditServiceCategoryComponent,
                canActivate: [EditServiceCategoryGuard],
                data: { title: 'lblServiceCategories', isEdit: true, breadcrumb: 'lblEditServiceCategory' }
              }
            ]
          },
          {
            path: 'services',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblServices',
              id: fromEnums.ModuleNames.Service,
              breadcrumb: 'lblServices'
            },
            children: [
              {
                path: '',
                data: { title: 'lblServices', isMain: true, breadcrumb: '' },
                component: ServicesComponent
              },
              {
                path: 'add',
                component: AddServiceComponent,
                data: { title: 'lblServices', isAdd: true, breadcrumb: 'lblAddService' }
              },
              {
                path: 'edit',
                component: EditServiceComponent,
                canActivate: [EditServiceGuard],
                data: { title: 'lblServices', isEdit: true, breadcrumb: 'lblEditService' }
              }
            ]
          },
          {
            path: 'labors',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblLabors',
              id: fromEnums.ModuleNames.Labor,
              breadcrumb: 'lblLabors'
            },
            children: [
              {
                path: '',
                data: { title: 'lblLabors', isMain: true, breadcrumb: '' },
                component: LaborComponent
              },
              {
                path: 'add-brand',
                component: AddBrandComponent,
                data: { title: 'lblBrands', isAdd: true, breadcrumb: 'lblAddBrand' }
              },
              {
                path: 'edit-brand',
                component: EditBrandComponent,
                canActivate: [EditBrandGuard],
                data: { title: 'lblBrands', isEdit: true, breadcrumb: 'lblEditBrand' }
              }
            ]
          },
          {
            path: 'preferences',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblPreferences', id: fromEnums.ModuleNames.Preferences, breadcrumb: 'lblPreferences' },
            children: [
              {
                path: '',
                data: { title: 'lblPreferences', isMain: true, breadcrumb: '' },
                component: PreferencesComponent
              },
            ]
          },
          {
            path: 'promotions',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblPromotions', id: fromEnums.ModuleNames.Promotions, breadcrumb: 'lblPromotions' },
            children: [
              {
                path: '',
                data: { title: 'lblPromotions', isMain: true, breadcrumb: '' },
                component: PromotionsComponent
              },
            ]
          },
          {
            path: 'category',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblCategory', id: fromEnums.ModuleNames.Category, breadcrumb: 'lblCategory' },
            children: [
              {
                path: '',
                data: { title: 'lblCategory', isMain: true, breadcrumb: '' },
                component: CategoryComponent
              },
            ]
          },
          {
            path: 'warning-light',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblWarningLight',
              id: fromEnums.ModuleNames.WarningLights,
              breadcrumb: 'lblWarningLight'
            },
            children: [
              {
                path: '',
                data: { title: 'lblWarningLight', isMain: true, breadcrumb: '' },
                component: WarningLightComponent
              }
            ]
          },
          {
            path: 'part-sales-price',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblPartSalesPriceCalculation',
              id: fromEnums.ModuleNames.PartSalesPriceCalculation,
              breadcrumb: 'lblPartSalesPriceCalculation'
            },
            children: [
              {
                path: '',
                data: { title: 'lblPartSalesPriceCalculation', isMain: true, breadcrumb: '' },
                component: PartSalesPriceCalculationComponent
              }
            ]
          },
          {
            path: 'labor-charging-price',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblLaborChargingGroupPrice',
              id: fromEnums.ModuleNames.LaborChargingGroupPrice,
              breadcrumb: 'lblLaborChargingGroupPrice'
            },
            children: [
              {
                path: '',
                data: { title: 'lblLaborChargingGroupPrice', isMain: true, breadcrumb: '' },
                component: LaborChargingGroupPriceComponent
              }
            ]
          }
        ]
      },
      {
        path: '',
        data: { breadcrumb: 'lblParts' },
        children: [
          {
            path: 'specialTool',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblSpecialTools', id: fromEnums.ModuleNames.SpecialTools, breadcrumb: 'lblSpecialTools' },
            children: [
              {
                path: '',
                data: { title: 'lblSpecialTools', isMain: true, breadcrumb: '' },
                component: SpecialToolComponent
              },
              {
                path: 'add-specialTool',
                data: { title: 'lblSpecialTools', isAdd: true, breadcrumb: 'lblAddSpecialTool' },
                component: AddSpecialToolComponent
              },
              {
                path: 'edit-specialTool',
                data: { title: 'lblSpecialTools', isEdit: true, breadcrumb: 'lblEditSpecialTool' },
                canActivate: [EdiSpecialToolGuard],
                component: EditSpecialToolComponent
              }
            ]
          },
          {
            path: 'package',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblPackages',
              id: fromEnums.ModuleNames.Package,
              breadcrumb: 'lblPackages'
            },
            children: [
              {
                path: '',
                data: { title: 'lblPackages', isMain: true, breadcrumb: '' },
                component: PackageComponent
              },
              {
                path: 'add',
                component: AddPackageComponent,
                data: { title: 'lblPackages', isAdd: true, breadcrumb: 'lblAddPackage' }
              }
            ]
          },
          {
            path: 'parts',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblParts', id: fromEnums.ModuleNames.Parts, breadcrumb: 'lblParts' },
            children: [
              {
                path: '',
                data: { title: 'lblParts', isMain: true, breadcrumb: '' },
                component: PartsComponent
              },
              {
                path: 'add-parts',
                data: { title: 'lblParts', isAdd: true, breadcrumb: 'lblAddParts' },
                component: AddPartsComponent
              },
              {
                path: 'edit-parts',
                data: { title: 'lblParts', isEdit: true, breadcrumb: 'lblEditParts' },
                component: EditPartsComponent,
                canActivate: [EditPartsServiceGuard]
              }
            ]
          },
        ]
      },
      {
        path: '',
        data: { breadcrumb: 'lblSysAdmin' },
        children: [
          {
            path: 'roles-rights',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblRolesRights', id: fromEnums.ModuleNames.RolesRights, breadcrumb: 'lblRolesRights' },
            children: [
              {
                path: '',
                data: { title: 'lblRolesRights', isMain: true, breadcrumb: '' },
                component: RolesRightsComponent
              },
              {
                path: 'edit',
                data: { title: 'lblRolesRights', isEdit: true, breadcrumb: 'lblEditRolesRights' },
                canActivate: [EditRoleRightsGuard],
                component: EditRolesRightsComponent
              }
            ]
          },
          {
            path: 'feature',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblFeature',
              id: fromEnums.ModuleNames.Feature,
              breadcrumb: 'lblFeature'
            },
            children: [
              {
                path: '',
                data: { title: 'lblFeature', isMain: true ,breadcrumb: ''},
                component: FeatureComponent
              }
            ]
          },
          {
            path: 'syncJobs',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblSyncJobs',
              id: fromEnums.ModuleNames.SyncJobs,
              breadcrumb: 'lblSyncJobs'
            },
            children: [
              {
                path: '',
                data: { title: 'lblSyncJobs', isMain: true ,breadcrumb: ''},
                component: SyncJobsComponent
              }
            ]
          },
          {
            path: 'action-type',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: {
              title: 'lblCommunicationEvent',
              id: fromEnums.ModuleNames.ActionType,
              breadcrumb: 'lblCommunicationEvent'
            },
            children: [
              {
                path: '',
                data: { title: 'lblCommunicationEvent', isMain: true ,breadcrumb: ''},
                component: ActionTypeComponent
              }
            ]
          },
        ]
      },
      {
        path: '',
        data: { breadcrumb: 'lblDMSValues' },
        children: [
          {
            path: 'dms-defaultvalues',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblDMSDefaultValues', id: fromEnums.ModuleNames.DMSDefaultValues, breadcrumb: 'lblDMSDefaultValues' },
            children: [
              {
                path: '',
                data: { title: 'lblDMSDefaultValues', isMain: true, breadcrumb: '' },
                component: DmsValuesComponent
              }
            ]
          }
        ]
      },
      {
        path: '',
        data: { breadcrumb: 'lblApplicationVersion' },
        children: [
          {
            path: 'application-version-details',
            canActivate: [MsalGuard],
            canActivateChild: [RoleAccessGuard, UserStampGuard],
            data: { title: 'lblApplicationVersionDetails', id: fromEnums.ModuleNames.ApplicationVersionDetails, breadcrumb: 'lblApplicationVersionDetails' },
            children: [
              {
                path: '',
                data: { title: 'lblApplicationVersionDetails', isMain: true, breadcrumb: '' },
                component: ApplicationVersionComponent
              }
            ]
          }
        ]
      },
      // {
      //   path: '',
      //   data: { breadcrumb: 'lblDMSValues' },
      //   children: [
      //    {
      //       path: 'dms-syncfailedlog',
      //       canActivate: [MsalGuard],
      //       canActivateChild: [RoleAccessGuard, UserStampGuard],
      //       data: { title: 'lblDMSSyncFailedlog', id: fromEnums.ModuleNames.DMSSyncFailedlog, breadcrumb: 'lblDMSSyncFailedlog' },
      //       children: [
      //         {
      //           path: '',
      //           data: { title: 'lblDMSSyncFailedlog', isMain: true, breadcrumb: '' },
      //           component: DmsSyncfailedlogComponent
      //         }
      //       ]
      //     }
      //   ]
      // }


    ]
  },
  {
    path: '',
    data: { breadcrumb: 'lblDWO' },
    children: [
      {
        path: 'checklist',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblCheckListmanagement', id: fromEnums.ModuleNames.ChecklistManagement,breadcrumb: 'lblCheckListmanagement' },
        children: [
          {
            path: '',
            data: { title: 'lblCheckListmanagement', isMain: true ,breadcrumb: ''},
            component: CheckListManagementComponent
          },
          {
            path: 'add/:id',
            component: AddCheckListComponent,
            data: { title: 'lblCheckListmanagement', isAdd: true ,breadcrumb: 'lblAddCheckList'}
          },
          {
            path: 'edit/:id',
            component: AddCheckListComponent,
            data: { title: 'lblCheckListmanagement', isEdit: true ,breadcrumb: 'lblEditCheckList'}
          },
          {
            path: 'additem/:id',
            component: AddCheckListItemsComponent,
            data: { title: 'lblCheckListmanagement', isAdd: true ,breadcrumb: 'lblAddCheckListItem'}
          },
          {
            path: 'edititem/:id',
            component: AddCheckListItemsComponent,
            data: { title: 'lblCheckListmanagement', isEdit: true ,breadcrumb: 'lblEditCheckListItem'}
          },
          {
            path: 'additem/:id',
            component: AddMulticplourChecklistItemComponent,
            data: { title: 'lblCheckListmanagement', isEdit: true ,breadcrumb: 'lblAddMultiColourcheckListItem'}
          }
        ]
      },
      {
        path: 'diagnoseChecklist',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblDiagnoseChecklist',
          id: fromEnums.ModuleNames.DiagnoseChecklist,
          breadcrumb: 'lblDiagnoseChecklist'
        },
        children: [
          {
            path: '',
            data: { title: 'lblDiagnoseChecklist', isMain: true, breadcrumb: ''},
            component: DiagnoseCheckListComponent
          },
          {
            path: 'add/:id',
            component: AddDiagnoseCheckListComponent,
            data: { title: 'lblDiagnoseChecklist', isAdd: true ,breadcrumb: 'lblAddDiagnoseCheckList'}
          },
          {
            path: 'edit/:id',
            component: AddDiagnoseCheckListComponent,
            data: { title: 'lblDiagnoseChecklist', isEdit: true ,breadcrumb: 'lblEditDiagnoseCheckList'}
          },
          {
            path: 'additem/:id',
            component: AddDiagnoseCheckListItemsComponent,
            data: { title: 'lblDiagnoseChecklist', isAdd: true ,breadcrumb: 'lblAddDiagnoseCheckListItem'}
          },
          {
            path: 'edititem/:id',
            component: AddDiagnoseCheckListItemsComponent,
            data: { title: 'lblDiagnoseChecklist', isEdit: true ,breadcrumb: 'lblEditDiagnoseCheckListItem'}
          }
        ]
      },
      {
        path: 'technicalManual',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblTechnicalManual',
          id: fromEnums.ModuleNames.TechnicalManual,
          breadcrumb: 'lblTechnicalManual'
        },
        children: [
          {
            path: '',
            data: { title: 'lblTechnicalManual', isMain: true,breadcrumb: '' },
            component: TechnicalManualComponent
          },
          {
            path: 'add-technicalManual',
            data: { title: 'lblTechnicalManual', isAdd: true,breadcrumb: 'lblAddManual' },
            component: AddTechnicalManualComponent
          },
          {
            path: 'view-technicalManual',
            canActivate: [EditTechnicalManualGuard],
            data: { title: 'lblTechnicalManual', isEdit: true,breadcrumb: 'lblViewTechnicalManual' },
            component: ViewTechnicalManualComponent
          }
        ]
      },
      {
        path: 'mechanicTimeCode',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblMechanicTimeCode',
          id: fromEnums.ModuleNames.MechanicTimecode,
          breadcrumb: 'lblMechanicTimeCode'
        },
        children: [
          {
            path: '',
            data: { title: 'lblMechanicTimeCode', isMain: true, breadcrumb: '' },
            component: MechanicTimeCodeComponent
          },
          {
            path: 'add-mechanicTimeCode',
            data: { title: 'lblMechanicTimeCode', isAdd: true, breadcrumb: 'lblAddMechanicTimeCode' },
            component: AddMechanicTimeCodeComponent
          },
          {
            path: 'edit-mechanicTimeCode',
            data: { title: 'lblMechanicTimeCode', isEdit: true, breadcrumb: 'lblEditMechanicTimeCode' },
            canActivate: [EditMechanicTimeCodeGuard],
            component: EditMechanicTimeCodeComponent
          }
        ]
      },
      {
        path: 'keyDropLocation',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblDealerKeyDropLocation',
          id: fromEnums.ModuleNames.DealerKeydropLocation,
          breadcrumb: 'lblDealerKeyDropLocation'
        },
        children: [
          {
            path: '',
            data: { title: 'lblDealerKeyDropLocation', isMain: true, breadcrumb: ''},
            component: DealerKeydropLocationComponent,
          },
          {
            path: 'add',
            data: { title: 'lblDealerKeyDropLocation', isAdd: true, breadcrumb: 'lblAddKeyDropLocation' },
            component: AddDealerKeydropLocationComponent
          },
          {
            path: 'edit',
            data: { title: 'lblDealerKeyDropLocation', isEdit: true, breadcrumb: 'lblEditKeyDropLocation' },
            component: EditDealerKeydropLocationComponent,
            canActivate: [EditKeydropLocationGuard]
          }
        ]
      },
      {
        path: 'diagnoseTemplate',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblDiagnoseTemplate',
          id: fromEnums.ModuleNames.DiagnoseTemplate,
          breadcrumb: 'lblDiagnoseTemplate'
        },
        children: [
          {
            path: '',
            data: { title: 'lblDiagnoseTemplate', isMain: true,breadcrumb: '' },
            component: DiagnoseTemplateComponent
          },
          {
            path: 'add-diagnoseTemplate',
            data: { title: 'lblDiagnoseTemplate', isAdd: true,breadcrumb: 'lblAddDiagnoseTemplate' },
            component: AddDiagnoseTemplateComponent
          },
          {
            path: 'edit-diagnoseTemplate',
            data: { title: 'lblDiagnoseTemplate', isEdit: true,breadcrumb: 'lblEditDiagnoseTemplate' },
            canActivate: [EditDiagnoseTemplateGuard],
            component: EditDiagnoseTemplateComponent
          }
        ]
      },
      {
        path: 'dealerParking',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: {
          title: 'lblUploadParkingImage',
          id: fromEnums.ModuleNames.UploadParkingImage,
          breadcrumb: 'lblUploadParkingImage'
        },
        children: [
          {
            path: '',
            data: { title: 'lblUploadParkingImage', isMain: true, breadcrumb: '' },
            component: DealerParkingComponent
          }
        ]
      },
    ]
  },

  {
    path: '',
    data: { breadcrumb: 'lblCampaignManagement' },
    children: [
      {
        path: 'campaign',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblCampaigns', id: fromEnums.ModuleNames.Campaigns, breadcrumb: 'lblCampaigns' },
        children: [
          {
            path: '',
            data: { title: 'lblCampaigns', isMain: true, breadcrumb: '' },
            component: CampaignComponent
          },]
        // {
        //   path: 'add-dealer',
        //   component: AddDealerComponent,
        //   data: { title: 'lblDealers', isAdd: true, breadcrumb: 'lblAddDealer' }
        // },
        // {
        //   path: 'edit-dealer',
        //   canActivate: [EditDealerGuard],
        //   component: EditDealerComponent,
        //   data: { title: 'lblDealers', isEdit: true, breadcrumb: 'lblEditDealer' }
        // }
        // ]
      },
      {
        path: 'targetedgroup',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblTargetedGroup', id: fromEnums.ModuleNames.TargetedGroup, breadcrumb: 'lblTargetedGroup' },
        children: [
          {
            path: '',
            data: { title: 'lblTargetedGroup',isMain: true, breadcrumb: '' },
            component: TargetedGroupComponent
          },]
        //   {
        //     path: 'add-reception',
        //     component: AddReceptionComponent,
        //     data: { title: 'lblReceptionUser', isAdd: true, breadcrumb: 'lblAddReception' }
        //   },
        //   {
        //     path: 'edit-reception',
        //     component: EditReceptionComponent,
        //     canActivate: [EditReceptionGuard],
        //     data: { title: 'lblReceptionUser', isEdit: true, breadcrumb: 'lblEditReception' }
        //   }
        // ]
      },
      {
        path: 'campaign-template',
        canActivate: [MsalGuard],
        canActivateChild: [RoleAccessGuard, UserStampGuard],
        data: { title: 'lblTemplate', id: fromEnums.ModuleNames.CampaignTemplate, breadcrumb: 'lblTemplate' },
        children: [
          {
            path: '',
            data: { title: 'lblTemplate', isMain: true, breadcrumb: '' },
            component: CampaignTemplateComponent
          }]
      }
    ]
  },
  {
    path: '',
    data: { breadcrumb: 'lblReport' },
    children: [
      {
        path: 'customerwaiting',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblCustomerWaiting', id: fromEnums.ModuleNames.CustomerWaiting, breadcrumb: 'lblCustomerWaiting' },
        children: [
          {
            path: '',
            data: { title: 'lblCustomerWaiting', isMain: true, breadcrumb: '' },
            component: CustomerWaitingComponent
          },]
      },
      {
        path: 'pickup-dropoff',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblVehiclePickup/DropOff', id: fromEnums.ModuleNames.PickupDropoff, breadcrumb: 'lblVehiclePickup/DropOff' },
        children: [
          {
            path: '',
            data: { title: 'lblVehiclePickup/DropOff',isMain: true, breadcrumb: '' },
            component: PickupDropoffComponent
          },]
      },
      {
        path: 'customer-pickup-dropoff',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblCustomerPick/Drop', id: fromEnums.ModuleNames.CustomerPickDrop, breadcrumb: 'lblCustomerPick/Drop' },
        children: [
          {
            path: '',
            data: { title: 'lblCustomerPick/Drop',isMain: true, breadcrumb: '' },
            component: CustomerDropComponent
          },]
      },
      {
        path: 'activeuser',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblActiveUsers', id: fromEnums.ModuleNames.ActiveUser, breadcrumb: 'lblActiveUsers' },
        children: [
          {
            path: '',
            data: { title: 'lblActiveUsers', isMain: true, breadcrumb: '' },
            component: CustomerWaitingComponent
          },]
      },
      {
        path: 'checkin-customer-connect',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblContactUsers', id: fromEnums.ModuleNames.ContactUser, breadcrumb: 'lblContactUsers' },
        children: [
          {
            path: '',
            data: { title: 'lblContactUsers', isMain: true, breadcrumb: '' },
            component: ContactUserComponent
          },]
      },
      {
        path: 'mechanic-efficiency',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        data: { title: 'lblMechanicEfficiencyReport', id: fromEnums.ModuleNames.MechanicEfficiencyReport, breadcrumb: 'lblMechanicEfficiencyReport' },
        children: [
          {
            path: '',
            data: { title: 'lblMechanicEfficiencyReport', isMain: true, breadcrumb: '' },
            component: MechanicEfficiencyReportComponent
          },]
      },
      {
        path: 'mechanic-accuracy',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        data: { title: 'lblMechanicAccuracyReport', id: fromEnums.ModuleNames.MechanicAccuracyReport, breadcrumb: 'lblMechanicAccuracyReport' },
        children: [
          {
            path: '',
            data: { title: 'lblMechanicAccuracyReport', isMain: true, breadcrumb: '',data:'MechanicAccuracyReport' },
            component: MechanicEfficiencyReportComponent
          },]
      },
      {
        path: 'mechanic-report',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        data: { title: 'lblMechanicReport', id: fromEnums.ModuleNames.MechanicReport, breadcrumb: 'lblMechanicReport' },
        children: [
          {
            path: '',
            data: { title: 'lblMechanicReport', isMain: true, breadcrumb: '' },
            component: MechanicReportComponent
          },]
      },
      {
        path: 'service-mechanicwise',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        data: { title: 'lblServiceMechanicWiseReport', id: fromEnums.ModuleNames.ServiceMechanicWiseReport, breadcrumb: 'lblServiceMechanicWiseReport' },
        children: [
          {
            path: '',
            data: { title: 'lblServiceMechanicWiseReport', isMain: true, breadcrumb: '' },
            component: ServiceMechanicWiseReportComponent
          },]
      },
      {
        path: 'cdss-call-summary',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblCDSSCallSummary', id: fromEnums.ModuleNames.AgentEfficiency, breadcrumb: 'lblCDSSCallSummary' },
        children: [
          {
            path: '',
            data: { title: 'lblCDSSCallSummary', isMain: true, breadcrumb: '' },
            component: DealerWiseAgentListComponent
          },]
      },         
      {
        path: 'app-call-logs',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblCallDealerLog', id: fromEnums.ModuleNames.CallDealerLogs, breadcrumb: 'lblCallDealerLog' },
        children: [
          {
            path: '',
            data: { title: 'lblCallDealerLog', isMain: true, breadcrumb: '' },
            component: DealerWiseCallHistoryComponent
          },]
      },      
      {
        path: 'checkin-usage',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblCheckInUsage', id: fromEnums.ModuleNames.CheckInUsage, breadcrumb: 'lblCheckInUsage' },
        children: [
          {
            path: '',
            data: { title: 'lblCheckInUsage', isMain: true, breadcrumb: '' },
            component: CheckinUserComponent
          },]
      },
      {
        path: 'deleted-planning',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblDeletedPlanning', id: fromEnums.ModuleNames.PickupDropoff, breadcrumb: 'lblDeletedPlanning' },
        children: [
          {
            path: '',
            data: { title: 'lblDeletedPlanning',isMain: true, breadcrumb: '' },
            component: DeletedPlanningComponent
          },]
      },      
      
      {
        path: 'user-appointment',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblUserViseAppointment', id: fromEnums.ModuleNames.UserViseAppointment, breadcrumb: 'lblUserViseAppointment' },
        children: [
          {
            path: '',
            data: { title: 'lblUserViseAppointment', isMain: true, breadcrumb: '' },
            component: UserViseAppointmentComponent
          },]
      },    
      {
        path: 'cdss-appointment',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblCDSSUserAppointment', id: fromEnums.ModuleNames.CdssAppointment, breadcrumb: 'lblCDSSUserAppointment' },
        children: [
          {
            path: '',
            data: { title: 'lblCDSSUserAppointment', isMain: true, breadcrumb: '' },
            component: CdssAppointmentComponent
          },]
      },  
      {
        path: 'dealer-upsell-report',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblTotalSoldHoursReport', id: fromEnums.ModuleNames.TotalSoldHoursReport, breadcrumb: 'lblTotalSoldHoursReport' },
        children: [
          {
            path: '',
            data: { title: 'lblTotalSoldHoursReport', isMain: true, breadcrumb: '' },
            component: TotalSoldHoursReportComponent
          },]
      },   
      {
        path: 'work-order-status',
        canActivate: [MsalGuard],
        data: { title: 'lblWorkOrderStatusReport', id: fromEnums.ModuleNames.WorkOrderStatusReport, breadcrumb: 'lblWorkOrderStatusReport' },
        children: [
          {
            path: '',
            data: { title: 'lblWorkOrderStatusReport', isMain: true, breadcrumb: '' },
            component: WorkOrderStatusComponent
          },]
      },
      {
        path: 'towedin-report',
        canActivate: [MsalGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblTowedInReport', id: fromEnums.ModuleNames.TowedInReport, breadcrumb: 'lblTowedInReport' },
        children: [
          {
            path: '',
            data: { title: 'lblTowedInReport', isMain: true, breadcrumb: '' },
            component: TowedInReportComponent
          },]
      }, 
      {
        path: 'additional-work-report',
        canActivate: [MsalGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblAdditionalWorkReport', id: fromEnums.ModuleNames.AdditionalWorkReport, breadcrumb: 'lblAdditionalWorkReport' },
        children: [
          {
            path: '',
            data: { title: 'lblAdditionalWorkReport', isMain: true, breadcrumb: '' },
            component: AdditionalWorkReportComponent
          },]
      },
      {
        path: 'error-log-analysis-report',
        canActivate: [MsalGuard],
        data: { title: 'lblErrorLogAnalysisReport', id: fromEnums.ModuleNames.ErrorLogAnalysisReport, breadcrumb: 'lblErrorLogAnalysisReport' },
        children: [
          {
            path: '',
            data: { title: 'lblErrorLogAnalysisReport', isMain: true, breadcrumb: '' },
            component: ErrorLogAnalysisReportComponent
          },]
      },
      {
        path: 'widget-appointment-report',
        canActivate: [MsalGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblWidgetAppointmentReport', id: fromEnums.ModuleNames.WidgetAppointmentReport, breadcrumb: 'lblWidgetAppointmentReport' },
        children: [
          {
            path: '',
            data: { title: 'lblWidgetAppointmentReport', isMain: true, breadcrumb: '' },
            component: WidgetAppointmentReportComponent
          },]
      }, 
    ]
  },
  
  {
    path: '',
    data: { breadcrumb: 'lblDeletedMaster' },
    children: [
      {
        path: 'deleted-customer',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        //canActivateChild: [RoleAccessGuard],
        data: { title: 'lblDeletedCustomers', id: fromEnums.ModuleNames.CustomerDelete, breadcrumb: 'lblDeletedCustomers' },
        children: [
          {
            path: '',
            data: { title: 'lblDeletedCustomers', isMain: true, breadcrumb: '' },
            component: DeletedCustomerComponent
          },]
      },
      {
        path: 'deleted-vehicle',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        // canActivateChild: [RoleAccessGuard],
        data: { title: 'lblDeletedVehicle', id: fromEnums.ModuleNames.VehicleDelete, breadcrumb: 'lblDeletedVehicle' },
        children: [
          {
            path: '',
            data: { title: 'lblDeletedVehicle', isMain: true, breadcrumb: '' },
            component: DeletedVehiclesComponent
          },]
      },
      {
        path: 'syncfail-appointment',
        canActivate: [MsalGuard],
        canActivateChild: [UserStampGuard],
        //canActivateChild: [RoleAccessGuard],
        data: { title: 'lblSyncFailAppointment', id: fromEnums.ModuleNames.CustomerDelete, breadcrumb: 'lblSyncFailAppointment' },
        children: [
          {
            path: '',
            data: { title: 'lblSyncFailAppointment', isMain: true, breadcrumb: '' },
            component: SyncFailAppointmentComponent
          },]
      }
    ]
    },
    {
      path: '',
      data: { breadcrumb: 'lblClocking' },
      children: [
        {
          path: 'timeStamp',
          canActivate: [MsalGuard],
          canActivateChild: [RoleAccessGuard, UserStampGuard],
          data: { title: 'lblTimeStamp', id: fromEnums.ModuleNames.TimeStamp, breadcrumb: 'lblTimeStamp' },
          children: [
            {
              path: '',
              data: { title: 'lblTimeStamp', isMain: true, breadcrumb: '' },
              component: TimeStampComponent
            }
          ]
        },   
        {
          path: 'user-clock-in-out',
          canActivate: [MsalGuard],
          canActivateChild: [RoleAccessGuard, UserStampGuard],
          data: {
            title: 'lblUserClockInOut',
            id: fromEnums.ModuleNames.UserClockInOut,
            breadcrumb: 'lblUserClockInOut'
          },
          children: [
            {
              path: '',
              data: { title: 'lblUserClockInOut', isMain: true ,breadcrumb: ''},
              component: UserClockInOutComponent
            }
          ]
        },
        {
          path: 'mechanic-clocking-time',
          canActivate: [MsalGuard],
          canActivateChild: [UserStampGuard],
          // canActivateChild: [RoleAccessGuard],
          data: { title: 'lblMechanicClockingReport', id: fromEnums.ModuleNames.MechanicClockingReport, breadcrumb: 'lblMechanicClockingReport' },
          children: [
            {
              path: '',
              data: { title: 'lblMechanicClockingReport',isMain: true, breadcrumb: '' },
              component:MechanicClockingTimeComponent
            },]
        }, 
        {
          path: 'time-stamp-report',
          canActivate: [MsalGuard],
          canActivateChild: [UserStampGuard],
          // canActivateChild: [RoleAccessGuard],
          data: { title: 'lblTimeStampReport', id: fromEnums.ModuleNames.TimeStampReport, breadcrumb: 'lblTimeStampReport' },
          children: [
            {
              path: '',
              data: { title: 'lblTimeStampReport', isMain: true, breadcrumb: '' },
              component: TimeStampReportComponent
            },]
        },  
        {
          path: 'wotimestamp-report',
          canActivate: [MsalGuard],
          canActivateChild: [UserStampGuard],
          // canActivateChild: [RoleAccessGuard],
          data: { title: 'lblWorkOrderTimeStampReport', id: fromEnums.ModuleNames.TimeStampReport, breadcrumb: 'lblWorkOrderTimeStampReport' },
          children: [
            {
              path: '',
              data: { title: 'lblWorkOrderTimeStampReport', isMain: true, breadcrumb: '' },
              component: WorkorderTimeStampReportComponent
            },]
        },      
        {
          path: 'user-stamp-report',
          canActivate: [MsalGuard],
          canActivateChild: [UserStampGuard],
          // canActivateChild: [RoleAccessGuard],
          data: { title: 'lblUserStampReport', id: fromEnums.ModuleNames.UserStampReport, breadcrumb: 'lblUserStampReport' },
          children: [
            {
              path: '',
              data: { title: 'lblUserStampReport', isMain: true, breadcrumb: '' },
              component: UserStampReportComponent
            },]
        },   
      ]
    },
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: false,
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled'
}),
    ToastrModule.forRoot(),
    NgxSpinnerModule
  ],
  exports: [RouterModule, MsalModule]
})
export class AppRoutingModule { }
